module.exports = __webpack_public_path__ + "static/media/bus-alt.12194b41.svg";